<a class="lm-skip lm-sr-only" href="#lm-main">Skip to content</a>

@if ((standalonePage$ | async) === false) {
<header class="lm-header">
  <div class="lm-shell lm-header__inner">
    <!-- ⚠ THE REAL LOGO, from the owner's own `lifemaan logo/` folder. It used to be the word
         "Lifemaan" set in the page font, which is not a logo — and the product's own
         `assets/images/lifemaanHeader.png` could not be used either: it is a solid white
         rectangle, 26,334 pixels of #ffffff and no artwork at all. -->
    <a class="lm-header__brand" routerLink="/plans" aria-label="Lifemaan — home">
      <img src="assets/brand/lifemaan-logo.png" alt="Lifemaan" width="168" height="53" />
    </a>

    <nav class="lm-header__nav" aria-label="Main">
      <a routerLink="/plans" routerLinkActive="is-active">Membership</a>
      <a routerLink="/find-care" routerLinkActive="is-active">Find care</a>
      <!-- Refer & Earn is in the bar itself (owner, 2026-09-17: "From where refer option is coming? it is
           not visible anywhere"). It used to be reachable only from inside My membership. -->
      <a routerLink="/refer" routerLinkActive="is-active">Refer &amp; Earn</a>
      <a routerLink="/my-membership" routerLinkActive="is-active">My membership</a>
    </nav>

    <div class="lm-header__actions">
      <a class="lm-btn lm-btn--primary lm-header__cta" href="/plans#plans" (click)="goToPlans($event)">Get your LifeCard</a>
      <!--
        D-D6 (owner, 2026-09-18): signing in is a SITE action, in the top-right, with the member's
        avatar once they are in — not something each page asks for in its own body. This is the only
        sign-in and sign-out control on the site.
      -->
      <lm-account-menu></lm-account-menu>
    </div>
  </div>
</header>
}

<main id="lm-main" class="lm-main" [class.lm-main--standalone]="standalonePage$ | async">
  <router-outlet></router-outlet>
</main>

@if ((standalonePage$ | async) === false) {

<footer class="lm-footer">
  <div class="lm-shell lm-footer__inner">
    <div class="lm-footer__brand">
      <img src="assets/brand/lifemaan-logo-white.png" alt="Lifemaan" width="176" height="55" />
      <p class="lm-footer__tag">More care &nbsp;|&nbsp; More access &nbsp;|&nbsp; A healthier tomorrow</p>
    </div>

    <nav class="lm-footer__links" aria-label="Footer">
      <a routerLink="/plans">Membership plans</a>
      <a routerLink="/find-care">Find a partner</a>
      <a routerLink="/refer">Refer &amp; Earn</a>
      <a routerLink="/my-membership">My membership</a>
      <a routerLink="/legal" [fragment]="legalFragment.TERMS">Terms &amp; Conditions</a>
      <a routerLink="/legal" [fragment]="legalFragment.PRIVACY">Privacy Policy</a>
      <a routerLink="/legal" [fragment]="legalFragment.CANCELLATION_REFUND">Cancellation &amp; Refund Policy</a>
    </nav>

    <div class="lm-footer__card">
      <img src="assets/brand/lifecard-logo.png" alt="LifeCard" width="54" height="71" />
      <span>Lifemaan Membership is issued as the <strong>LifeCard</strong>.</span>
    </div>

    @if (contact$ | async; as c) {<section class="lm-footer__contact" aria-labelledby="lm-footer-contact-title">
      <h2 class="lm-footer__contactTitle" id="lm-footer-contact-title">Contact us</h2>
      @if (c.email) {<a [href]="'mailto:' + c.email">{{ c.email }}</a>}
      @if (c.phone) {@if (phoneHref(c.phone); as href) {<a [href]="href">{{ c.phone }}</a>} @else {<span>{{ c.phone }}</span>}}
      @if (c.hours) {<span class="lm-footer__contactHours">{{ c.hours }}</span>}
    </section>}
  </div>
</footer>

<nav class="lm-bottom" aria-label="Sections">
  <a routerLink="/plans" routerLinkActive="is-active">
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <rect x="2.5" y="5" width="19" height="14" rx="2.5"></rect>
      <path d="M2.5 10h19"></path>
    </svg>
    <span>Membership</span>
  </a>
  <a routerLink="/find-care" routerLinkActive="is-active">
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="11" cy="11" r="6.5"></circle>
      <path d="M16 16l4.5 4.5"></path>
    </svg>
    <span>Find care</span>
  </a>
  <a routerLink="/refer" routerLinkActive="is-active">
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M20 12v8.5H4V12"></path>
      <rect x="2.5" y="7.5" width="19" height="4.5" rx="1"></rect>
      <path d="M12 20.5v-13M12 7.5H8.2a2.3 2.3 0 110-4.6C11 2.9 12 7.5 12 7.5zM12 7.5h3.8a2.3 2.3 0 100-4.6C13 2.9 12 7.5 12 7.5z"></path>
    </svg>
    <span>Refer</span>
  </a>
  <a routerLink="/my-membership" routerLinkActive="is-active">
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="12" cy="8.5" r="3.5"></circle>
      <path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6"></path>
    </svg>
    <span>My card</span>
  </a>
</nav>
}
